var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "ImagesPagination",
        {
          attrs: {
            "per-page": _vm.perPage,
            "stock-images": _vm.filteredStockImages,
          },
          model: {
            value: _vm.page,
            callback: function callback($$v) {
              _vm.page = $$v
            },
            expression: "page",
          },
        },
        [
          _c("ImagesList", {
            attrs: {
              "checked-images": _vm.checkedImages,
              page: _vm.page,
              "per-page": _vm.perPage,
              "stock-images": _vm.filteredStockImages,
            },
            on: {
              checked: _vm.onCheckboxChange,
              "open-page": function openPage(newPage) {
                return (_vm.page = newPage)
              },
              search: _vm.onSearch,
              select: _vm.onSelectImage,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "MountingPortal",
        {
          attrs: {
            mountTo: "#stock-images-widget",
            name: "sidebar-stock-images",
          },
        },
        [
          _c("SearchWidget", {
            attrs: {
              query: _vm.query,
            },
            on: {
              search: _vm.onSearch,
            },
          }),
          _vm._v(" "),
          _c("OrientationFilterWidget", {
            model: {
              value: _vm.filters,
              callback: function callback($$v) {
                _vm.filters = $$v
              },
              expression: "filters",
            },
          }),
          _vm._v(" "),
          _c("ColorFilterWidget", {
            model: {
              value: _vm.filters,
              callback: function callback($$v) {
                _vm.filters = $$v
              },
              expression: "filters",
            },
          }),
          _vm._v(" "),
          _c("ActionsWidget", {
            on: {
              initiateUpload: _vm.onUploadDialogShow,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("EditDialog", {
        attrs: {
          "stock-image": _vm.selectedImage,
          "suggested-tags": _vm.suggestedTags,
        },
        on: {
          confirm: _vm.onEditDialogConfirm,
          cancel: function cancel($event) {
            _vm.selectedImage = null
          },
        },
      }),
      _vm._v(" "),
      _c("UploadDialog", {
        attrs: {
          show: _vm.showUpload,
          "suggested-tags": _vm.suggestedTags,
        },
        on: {
          confirm: _vm.onUploadDialogConfirm,
          cancel: function cancel($event) {
            _vm.showUpload = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }